import { createFileRoute } from "@tanstack/react-router";
import { FoundationsDesignSystem } from "@/pages/design-system/FoundationsDesignSystem";

export const Route = createFileRoute("/demo/design-system/foundations/")({
  component: FoundationsDesignSystem,
});
